import { ConfigurationRepositoryWorkspacesService } from '@festina/configuration-general-types/configuration/services/ConfigurationRepositoryWorkspacesService'
import type { ConfigurableServer } from '@festina-life/core'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import * as configurationKeys from '../keys/configuration'

type RemoveWorkspaceOperationInputArguments = {
  server: ConfigurableServer
  workspaceName: string
  operationKey: string
}

export const useRemoveWorkspaceOperation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      server,
      workspaceName,
      operationKey,
    }: RemoveWorkspaceOperationInputArguments) => {
      await ConfigurationRepositoryWorkspacesService.workspaceServiceDeleteDeleteWorkspaceOperation(
        {
          workspaceName,
          operationKey,
          componentName: server.toLocaleLowerCase(),
        },
      )
    },
    onSuccess: async (_, variables) => {
      await queryClient.invalidateQueries({
        queryKey: configurationKeys.fetchWorkspaceOperationsKey({
          workspaceName: variables.workspaceName,
          server: variables.server,
        }),
      })

      await queryClient.invalidateQueries({
        queryKey: configurationKeys.fetchWorkspaceAllErrorsKeyPrefix({
          server: variables.server,
          workspaceName: variables.workspaceName,
        }),
      })
    },
  })
}
